// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/attachment.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { SharedContentPreview } from "./message_content_pb.js";

/**
 * @generated from enum social.chat.entity.v2.UploadType
 */
export const UploadType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.UploadType",
  [
    {no: 0, name: "UPLOAD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UPLOAD_TYPE_PICTURE", localName: "PICTURE"},
    {no: 2, name: "UPLOAD_TYPE_DOCUMENT", localName: "DOCUMENT"},
    {no: 3, name: "UPLOAD_TYPE_STICKER", localName: "STICKER"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.AttachmentType
 */
export const AttachmentType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.AttachmentType",
  [
    {no: 0, name: "ATTACHMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ATTACHMENT_TYPE_UPLOADED", localName: "UPLOADED"},
    {no: 2, name: "ATTACHMENT_TYPE_SHARED", localName: "SHARED"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.AttachmentMeta
 */
export const AttachmentMeta = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.AttachmentMeta",
  () => [
    { no: 1, name: "picture", kind: "message", T: PictureMeta, oneof: "meta" },
    { no: 2, name: "document", kind: "message", T: DocumentMeta, oneof: "meta" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PictureMeta
 */
export const PictureMeta = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.PictureMeta",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * reserve for later
 *
 * @generated from message social.chat.entity.v2.DocumentMeta
 */
export const DocumentMeta = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.DocumentMeta",
  [],
);

/**
 * @generated from message social.chat.entity.v2.UploadAttachment
 */
export const UploadAttachment = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.UploadAttachment",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(UploadType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "meta", kind: "message", T: AttachmentMeta },
  ],
);

/**
 * @generated from message social.chat.entity.v2.AttachmentV2
 */
export const AttachmentV2 = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.AttachmentV2",
  () => [
    { no: 1, name: "upload", kind: "message", T: UploadAttachment, oneof: "attachment" },
    { no: 2, name: "shared", kind: "message", T: SharedContentPreview, oneof: "attachment" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.UploadAttachmentParam
 */
export const UploadAttachmentParam = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.UploadAttachmentParam",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(UploadType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

